import { render, staticRenderFns } from "./PaymentBreakdownSummary.template.vue?vue&type=template&id=472610b8&scoped=true&"
var script = {}
import style0 from "./PaymentBreakdownSummary.template.vue?vue&type=style&index=0&id=472610b8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472610b8",
  null
  
)

export default component.exports